import React, { FC, Fragment, ReactNode, useEffect } from "react";

interface Props {
  customColor?: string | null;
  children: ReactNode;
}

export const WhiteBackground: FC<Props> = ({ customColor, children }) => {
  useEffect(() => {
    // body-surface resolves to var(--surface): white in light, dark card in
    // dark (defined in src/theme/tokens.ts themeGlobalStyles).
    const classname = customColor ? `bg[${customColor}]` : "body-surface";
    document.body.classList.add(classname);
    return () => {
      document.body.classList.remove(classname);
    };
  }, [customColor]);

  return <Fragment key="white-color-background">{children}</Fragment>;
};
